<template>
    <div
        class="modal fade"
        id="editCustomerRefModal"
        tabindex="-1"
        aria-labelledby="editCustomerRefModalLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="editCustomerRefModalLabel">
                        Modal Edit Customer Ref
                    </h5>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>
                <div class="modal-body">
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Customer</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control" style="width: 100%">
                                    <div class="select" style="width: 100%">
                                        <select
                                            id="edit_part_select"
                                            v-model="inputCustomer"
                                            style="width: 100%"
                                        >
                                            <option disabled hidden value="" style="color: var(--color-text-muted)">
                                                Customer
                                            </option>
                                            <option
                                                v-for="(customer, index) in customerItems"
                                                :value="customer"
                                                :key="index"
                                            >
                                                {{ customer }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Reference</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input
                                        id="modal_input_reference"
                                        v-model="localCustomerRef"
                                        class="input"
                                        maxlength="40"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="buttons is-right" style="width: 100%">
                        <button class="button is-danger" @click="doClose()">Cancel</button>
                        <button class="button is-success" @click="doSubmit()">Submit</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Modal } from 'bootstrap'
    import { useDropdownsStore } from '@/stores/dropdownsStore'

    export default {
        name: 'ModalEditCustomerReference',
        computed: {
            dropdownsStore() {
                return useDropdownsStore()
            },
            inputCustomer: {
                get() {
                    return this.dropdownsStore.search_action_customer
                },
                set(value) {
                    this.dropdownsStore.setSearchActionCustomer(value)
                },
            },
            localCustomerRef: {
                get() {
                    return this.dropdownsStore.search_action_customer_ref
                },
                set(value) {
                    this.dropdownsStore.setSearchActionCustomerRef(value)
                },
            },
        },
        props: {
            customerItems: {
                type: Array,
                required: true,
            },
        },
        methods: {
            doClose() {
                const modalElement = document.getElementById('editCustomerRefModal')
                if (modalElement) {
                    const modal = Modal.getInstance(modalElement) || new Modal(modalElement)
                    modal.hide()
                }
                this.$emit('doClose')
            },
            doSubmit() {
                this.$emit('doSubmit', {
                    customer: this.inputCustomer,
                    reference: this.localCustomerRef,
                })

                const modalElement = document.getElementById('editCustomerRefModal')
                if (modalElement) {
                    const modal = Modal.getInstance(modalElement) || new Modal(modalElement)
                    modal.hide()
                }
            },
        },
    }
</script>
